import {
  FETCH_PRIVATEEXPOSUREASSETCHART_BEGIN,
  FETCH_PRIVATEEXPOSUREASSETLEVELCHART_SUCCESS,
  FETCH_PRIVATEEXPOSUREASSETCHART_FAILURE,
  FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_BEGIN,
  FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_SUCCESS,
  FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_FAILURE,
} from "../constants/privateExposure";

const initialState = { 
  AssetLevelChart:{}, 
  CategoryTypeDates: {},
  error: "",
  isLoading: false
};

export const getPrivateExposureReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PRIVATEEXPOSUREASSETCHART_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_PRIVATEEXPOSUREASSETCHART_FAILURE:
      return {
        ...state,
        isLoading: true,
        error: payload.error,
      };
    case FETCH_PRIVATEEXPOSUREASSETLEVELCHART_SUCCESS:
      return {
        ...state,
        isLoading: false,
        AssetLevelChart: payload.AssetLevelChart,
      };
    case FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_FAILURE:
      return {
        ...state,
        isLoading: true,
        error: payload.error,
      };
    case FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        CategoryTypeDates: payload.CategoryTypeDates,
      };
    default:
      return state;
  }
};

export default getPrivateExposureReducer;
